(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["catalog-product-details"] && !Shopify.designMode) return;
  try {
    
function initCatalogDetails(){
  document.querySelectorAll('.catalog-details').forEach(function(root){
    if(root.dataset.ready)return;
    root.dataset.ready='true';
    var links=Array.from(root.querySelectorAll('[data-detail-image]'));
    var dialog=root.querySelector('dialog');
    if(!dialog||!links.length)return;
    var image=dialog.querySelector('.catalog-details__large');
    var caption=dialog.querySelector('.catalog-details__caption');
    var index=0;
    var opener=null;
    function display(next){index=(next+links.length)%links.length;image.src=links[index].href;image.alt=links[index].dataset.caption||'';caption.textContent=image.alt;dialog.querySelector('[data-detail-prev]').hidden=links.length<2;dialog.querySelector('[data-detail-next]').hidden=links.length<2}
    links.forEach(function(link,i){link.addEventListener('click',function(event){if(!dialog.showModal)return;event.preventDefault();opener=link;display(i);dialog.showModal()})});
    dialog.querySelector('[data-detail-prev]').addEventListener('click',function(){display(index-1)});
    dialog.querySelector('[data-detail-next]').addEventListener('click',function(){display(index+1)});
    dialog.querySelector('[data-detail-close]').addEventListener('click',function(){dialog.close()});
    dialog.addEventListener('keydown',function(event){if(event.key==='ArrowLeft'){event.preventDefault();display(index-1)}if(event.key==='ArrowRight'){event.preventDefault();display(index+1)}});
    dialog.addEventListener('click',function(event){if(event.target===dialog){var bounds=dialog.getBoundingClientRect();if(event.clientX<bounds.left||event.clientX>bounds.right||event.clientY<bounds.top||event.clientY>bounds.bottom)dialog.close()}});
    dialog.addEventListener('close',function(){if(opener)opener.focus()});
  });
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initCatalogDetails)}else{initCatalogDetails()}
document.addEventListener('shopify:section:load',initCatalogDetails);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
